module.exports = __webpack_public_path__ + "img/desserts.2cdbe07b.png";